import { DocumentType } from "./document-type";
import { Ownership } from "./ownership";

export class Requirement {

  public id: string;
  public name: string;
  public fileId: string;
  public sortOrder: number;
  public isInRenameMode: boolean;
  public documentCode: string;
  public businessKey: string;
  public types: DocumentType[] = [];
  public ownership: Ownership = new Ownership();

}
